import { axios } from '../../services/axios';

export const createTag = ({ name, type }) => axios.post('/tags', { name, type });
